module.exports = __webpack_public_path__ + "static/media/13a.e7276332.jpg";